export default "__VITE_ASSET__4d98d575__"